package music.limasoul.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.repository.EventRepository
import music.jammers.shared.event.domain.model.EventDetails
import music.jammers.shared.event.domain.model.EventFreezeData

class FreezeEventUseCase(
    private val eventRepository: EventRepository,
) {

    suspend fun invoke(id: Long, freezeData: EventFreezeData): EventDetails =
        eventRepository.freeze(id, freezeData)
}